import { useState, useEffect } from 'react';
import { fetchSiteSettings } from '../lib/sanity';

const STORAGE_KEY = 'revian-grain-animation-enabled';

export const useGrainAnimation = () => {
  const [grainAnimationEnabled, setGrainAnimationEnabledState] = useState<boolean>(() => {
    // Check localStorage first
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored !== null) {
      return stored === 'true';
    }
    // Default to true
    return true;
  });

  // Fetch from Sanity settings on mount
  useEffect(() => {
    fetchSiteSettings().then((data) => {
      if (data?.grainAnimationEnabled !== undefined) {
        const shouldEnable = data.grainAnimationEnabled;
        setGrainAnimationEnabledState(shouldEnable);
        localStorage.setItem(STORAGE_KEY, String(shouldEnable));
      }
    });
  }, []);

  const setGrainAnimationEnabled = (enabled: boolean) => {
    setGrainAnimationEnabledState(enabled);
    localStorage.setItem(STORAGE_KEY, String(enabled));
    // Dispatch custom event so other components can listen
    window.dispatchEvent(new CustomEvent('grain-animation-change', { detail: enabled }));
  };

  // Listen for changes from other components
  useEffect(() => {
    const handleStorageChange = (e: CustomEvent<boolean>) => {
      setGrainAnimationEnabledState(e.detail);
    };

    window.addEventListener('grain-animation-change', handleStorageChange as EventListener);
    return () => {
      window.removeEventListener('grain-animation-change', handleStorageChange as EventListener);
    };
  }, []);

  return { grainAnimationEnabled, setGrainAnimationEnabled };
};
